import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-associations',
  templateUrl: './associations.component.html',
  styleUrls: ['./associations.component.css']
})
export class AssociationsComponent implements OnInit {
list = [
  { title: 'ASIS', copy: 'American Society for Industrial Security'},
  { title: 'CAOS', copy: 'Collegiate Athletic Operations Services'},
  { title: 'CEFMA', copy: 'Collegiate Event & Facility Management Association'},
  { title: 'DHS', copy: 'Department of Homeland Security',
    subList: [
    {text: '- Designated at Certification Level'},
    {text: '- Commercial Facilities Sector'},
    {text: '- Office for Bombing Prevention'},
    {text: '- SAFETY Act Office'},
    {text: '- If You See Something Say Something'}

  ]},
  { title: 'IACP', copy: 'International Association of Chiefs of Police'},
  { title: 'OSAI', copy: 'Office of Safety Act Implementation'},
  { title: 'SMA', copy: 'Stadium Managers Association'},
  { title: 'TEAM', copy: 'Techniques for Effective Alcohol Management'}
];

images = [
  {imgName: 'ASIS', imgPath: 'https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2Fassociations%2Fasis.png?alt=media&token=81744d7b-abb9-4bbf-963f-799d45a092fd'},
  {imgName: 'CAOS', imgPath: 'https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2Fassociations%2FCAOS.png?alt=media&token=cc07721b-57b6-493e-9d6c-c4e8ffe6e0f2'},
  {imgName: 'CEFMA', imgPath: 'https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2Fassociations%2FCEFMA.png?alt=media&token=e5179a74-b878-4a9a-a0ef-6a9def8b90a0'},
  {imgName: 'DHS', imgPath: 'https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2Fassociations%2FDHS.png?alt=media&token=6ede9509-65f4-4efa-820b-6e8a6e5f4d0b'},
  {imgName: 'IAC', imgPath: 'https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2Fassociations%2FIAC.png?alt=media&token=26666ea1-08e9-462d-a263-68e005016e94'},
  {imgName: 'IAVM', imgPath: 'https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2Fassociations%2FIAVM.png?alt=media&token=8f58668e-c24b-4afc-bc4f-7bb2d822845e'},
  {imgName: 'NCS4', imgPath: 'https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2Fassociations%2FNCS4.png?alt=media&token=2f09798c-0cbd-4ffa-87e5-ee1a1fbbe82d'},
  {imgName: 'SMA', imgPath: 'https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2Fassociations%2FSMA.png?alt=media&token=253e8951-0989-434b-97db-b5b518a48731'},
  {imgName: 'Team', imgPath: 'https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2Fassociations%2FTeam.png?alt=media&token=d803d4a2-eee4-40c5-a6a1-12dde826a3b3'},
];
  constructor() { }

  ngOnInit(): void {}
}
